<form
  id="ngForm"
  [formGroup]="addBankAccountForm"
  (ngSubmit)="submitBankAccountData()"
>
  <ion-grid>
    <ion-col>
      <ion-row>
        <!-- Nick Name -->
        <ion-item
          *ngIf="
            showNickNameField &&
            addBankAccountForm.controls.nickName as nickNameControl
          "
        >
          <ion-label
            position="stacked"
            data-cy="add-bank-account-modal-nick-name-label"
          >
            {{ 'i18n.payments.addBankAccountModal.nickName' | translate }}
          </ion-label>
          <ion-input
            data-cy="add-bank-account-modal-nick-name-input"
            formControlName="nickName"
            maxlength="30"
            placeholder="{{
              'i18n.payments.addBankAccountModal.nickNamePlaceholder'
                | translate
            }}"
            type="text"
            (focusin)="nickNameControl.markAsUntouched()"
          >
          </ion-input>
        </ion-item>
      </ion-row>
      <ng-container *ngIf="showRoutingNumberField">
        <ion-row>
          <!-- Routing Number -->
          <ion-item
            *ngIf="
              addBankAccountForm.controls.routingNumber as routingNumberControl
            "
            [class.error]="
              routingNumberControl.touched && routingNumberControl.errors
            "
            class="routingNumber"
          >
            <ion-label
              position="stacked"
              data-cy="add-bank-account-modal-routing-number-label"
            >
              {{
                'i18n.payments.addBankAccountModal.routingNumber' | translate
              }}
              <ion-icon
                id="routing-number"
                name="information-circle-outline"
                (click)="openCheckReference($event)"
              ></ion-icon>
            </ion-label>
            <ion-input
              data-private
              data-cy="add-bank-account-modal-routing-number-input"
              formControlName="routingNumber"
              inputmode="numeric"
              maxlength="9"
              numeric
              placeholder="{{
                'i18n.payments.addBankAccountModal.routingNumberPlaceholder'
                  | translate
              }}"
              type="text"
            >
            </ion-input>
          </ion-item>

          <span
            *ngIf="
              addBankAccountForm.controls?.routingNumber.touched &&
              (routingNumberErrorKey === 'minlength' ||
                routingNumberErrorKey === 'maxlength')
            "
            class="error"
          >
            {{ 'i18n.payments.addBankAccountModal.9digitsError' | translate }}
          </span>
          <span
            *ngIf="
              addBankAccountForm.controls?.routingNumber.touched &&
              routingNumberErrorKey === 'required'
            "
            class="error"
          >
            {{ 'i18n.payments.addBankAccountModal.requiredError' | translate }}
          </span>
          <span
            *ngIf="
              addBankAccountForm.controls?.routingNumber.touched &&
              (routingNumberErrorKey === 'invalidRoutingNumber' ||
                routingNumberErrorKey === 'pattern')
            "
            class="error"
          >
            {{
              'i18n.payments.addBankAccountModal.invalidRoutingNumberError'
                | translate
            }}
          </span>
        </ion-row>
        <ion-row>
          <!-- Bank Name -->
          <ion-item
            [disabled]="!isBankNameInputEnabled"
            *ngIf="addBankAccountForm.controls?.bankName as bankNameControl"
            [class.error]="isBankNameInputEnabled && bankNameControl.errors"
          >
            <ion-label
              id="bank-name"
              position="stacked"
              data-cy="add-bank-account-modal-bank-name-label"
            >
              {{ 'i18n.payments.addBankAccountModal.bankName' | translate }}
            </ion-label>
            <ion-input
              aria-labelledby="bank-name"
              data-cy="add-bank-account-modal-bank-name-input"
              formControlName="bankName"
              [disabled]="!isBankNameInputEnabled"
              [readonly]="!isBankNameInputEnabled"
              maxlength="25"
              [placeholder]="
                isBankNameInputEnabled
                  ? ('i18n.payments.addBankAccountModal.bankNamePlaceholder'
                    | translate)
                  : ''
              "
            ></ion-input>
          </ion-item>
          <span
            *ngIf="
              isBankNameInputEnabled &&
              addBankAccountForm.controls?.bankName.errors?.unknownRoutingNumber
            "
            class="error"
          >
            {{
              'i18n.payments.addBankAccountModal.unknownRoutingNumberError'
                | translate
            }}
          </span>
          <span
            *ngIf="
              isBankNameInputEnabled &&
              addBankAccountForm.controls?.bankName.touched &&
              addBankAccountForm.controls?.bankName.errors?.required
            "
            class="error"
          >
            {{ 'i18n.payments.addBankAccountModal.requiredError' | translate }}
          </span>
        </ion-row>
        <ion-row>
          <!-- Checking Account Number -->
          <ion-item
            *ngIf="
              addBankAccountForm.controls
                ?.checkingAccountNumber as checkingAccountNumberControl
            "
            [class.error]="
              checkingAccountNumberControl.touched &&
              checkingAccountNumberControl.errors
            "
          >
            <ion-label
              id="bank-account-number"
              position="stacked"
              data-cy="add-bank-account-modal-account-number-label"
            >
              {{
                'i18n.payments.addBankAccountModal.checkingAccountNumber'
                  | translate
              }}
              <ion-icon
                id="account-number"
                name="information-circle-outline"
                (click)="openCheckReference($event)"
              ></ion-icon>
            </ion-label>
            <app-show-hide-input>
              <ion-input
                data-private
                aria-labelledby="bank-account-number"
                numeric
                data-cy="add-bank-account-modal-account-number-input"
                formControlName="checkingAccountNumber"
                inputmode="numeric"
                maxlength="17"
                placeholder="{{
                  'i18n.payments.addBankAccountModal.accountNumberPlaceholder'
                    | translate
                }}"
                type="password"
                (focusin)="checkingAccountNumberControl.markAsUntouched()"
              >
              </ion-input>
            </app-show-hide-input>
          </ion-item>
          <span
            *ngIf="
              addBankAccountForm.controls?.checkingAccountNumber.touched &&
              addBankAccountForm.controls.checkingAccountNumber.errors
            "
            class="error"
          >
            <ng-container
              *ngIf="
                addBankAccountForm.controls?.checkingAccountNumber.errors
                  ?.minlength
              "
            >
              {{
                'i18n.payments.addBankAccountModal.min5digitsError' | translate
              }}</ng-container
            >

            <ng-container
              *ngIf="
                addBankAccountForm.controls?.checkingAccountNumber.errors
                  ?.required
              "
            >
              {{
                'i18n.payments.addBankAccountModal.requiredError' | translate
              }}</ng-container
            >
          </span>
        </ion-row>
        <ion-row>
          <!-- Confirm Checking Account Number -->
          <ion-item
            *ngIf="
              addBankAccountForm.controls
                .confirmCheckingAccountNumber as confirmChkAccNumControl
            "
            [class.error]="
              confirmChkAccNumControl.touched && confirmChkAccNumControl.errors
            "
          >
            <ion-label
              id="confirm-bank-account-number"
              position="stacked"
              data-cy="add-bank-account-modal-confirm-account-number-label"
            >
              {{
                'i18n.payments.addBankAccountModal.confirmCheckingAccountNumber'
                  | translate
              }}
            </ion-label>
            <app-show-hide-input>
              <ion-input
                data-private
                aria-labelledby="confirm-bank-account-number"
                numeric
                data-cy="add-bank-account-modal-confirm-account-number-input"
                formControlName="confirmCheckingAccountNumber"
                inputmode="numeric"
                maxlength="17"
                [placeholder]="
                  'i18n.payments.addBankAccountModal.accountNumberPlaceholder'
                    | translate
                "
                type="password"
                (focusin)="confirmChkAccNumControl.markAsUntouched()"
              >
              </ion-input>
            </app-show-hide-input>
          </ion-item>
          <span
            *ngIf="
              addBankAccountForm.controls.confirmCheckingAccountNumber
                .touched &&
              addBankAccountForm.controls.confirmCheckingAccountNumber.errors
            "
            class="error"
          >
            <ng-container
              *ngIf="
                addBankAccountForm.controls.confirmCheckingAccountNumber.errors
                  ?.required
              "
            >
              {{
                'i18n.payments.addBankAccountModal.requiredError' | translate
              }}</ng-container
            >

            <ng-container
              *ngIf="
                addBankAccountForm.controls.confirmCheckingAccountNumber.errors
                  ?.mustMatch
              "
            >
              {{
                'i18n.payments.addBankAccountModal.accNumMustMatchError'
                  | translate
              }}</ng-container
            >
          </span>
        </ion-row>
      </ng-container>
      <ion-row>
        <!-- Select Customers in mobile -->
        <ion-item *ngIf="canSelectCustomers && !isDesktop">
          <ion-label
            id="select-customers"
            position="stacked"
            data-cy="add-bank-account-modal-select-customers-label"
          >
            {{ 'i18n.payments.addBankAccountModal.customers' | translate }}
          </ion-label>
          <div class="select-customer-input">
            <ion-input
              aria-labelledby="select-customers"
              data-cy="add-bank-account-modal-select-customers-input"
              [readonly]="true"
              [value]="
                selectedCustomers.length > 0
                  ? 'Selected: ' + selectedCustomers.length
                  : ''
              "
              (click)="openSelectCustomers()"
              [placeholder]="
                selectedCustomers.length === 0
                  ? ('i18n.payments.addBankAccountModal.noneSelected'
                    | translate)
                  : ''
              "
            >
            </ion-input>
            <ion-icon
              (click)="openSelectCustomers()"
              name="chevron-forward-outline"
            ></ion-icon>
          </div>
        </ion-item>
      </ion-row>
      <ion-row>
        <!-- isPrimary Checkbox -->
        <ion-item
          *ngIf="
            showIsPrimaryField &&
            addBankAccountForm.controls?.isPrimary as isPrimaryControl
          "
          lines="none"
        >
          <ng-container *ngIf="!isDesktop; else checkboxPrimary">
            <ion-toggle
              formControlName="isPrimary"
              data-cy="add-bank-account-modal-primary-checkbox"
              labelPlacement="end"
              justify="start"
            >
              {{
                'i18n.payments.addBankAccountModal.primaryAccountMsg'
                  | translate
              }}
            </ion-toggle>
          </ng-container>

          <ng-template #checkboxPrimary>
            <ion-checkbox
              formControlName="isPrimary"
              data-cy="add-bank-account-modal-primary-checkbox"
              labelPlacement="end"
              justify="start"
            >
              <span data-cy="add-bank-account-modal-primary-checkbox-label">
                {{
                  'i18n.payments.addBankAccountModal.primaryAccountMsg'
                    | translate
                }}
              </span>
            </ion-checkbox>
          </ng-template>
        </ion-item>
      </ion-row>
    </ion-col>
  </ion-grid>
</form>
